export default __webpack_public_path__ + "static/media/codigo-de-etica.c6484669.pdf";